import { MULTIPLE_COVER_CONTENT } from "../actions/file";

export const multipleCoverContentReducer = (state = '', action) => {
  switch (action.type) {
    case MULTIPLE_COVER_CONTENT:
      return action.payload;
  }
  return state;
};
